import { Col, Row, Button, message } from 'antd';
import React, { useState, useRef, useEffect } from 'react';
import { apiHolder as api, apis } from 'api';
import readWrapper from '@web-mail/components/ReadMail/util';
import classes from './preview.module.scss';
import { ReactComponent as IconClose } from '@/images/icons/edm/template-group-close.svg';
import { ReactComponent as IconLeft } from '@/images/icons/edm/template-group-left.svg';
import { ReactComponent as IconRight } from '@/images/icons/edm/template-group-right.svg';
import { ReactComponent as IconBack } from '@/images/icons/edm/template-group-back.svg';
import { formatViewMail } from '@web-setting/Mail/components/CustomTemplate/util';
import { setTemplateContent } from '../template-util';
import { navigate } from '@reach/router';
import { getIn18Text, apiHolder } from 'api';
const { isMac } = apiHolder.env;
const systemApi = apiHolder.api.getSystemApi();
const isWindows = systemApi.isElectron() && !isMac;
const templateApi = api.api.requireLogicalApi(apis.mailTemplateImplApi);
const dataMap = [
    {
        label: getIn18Text('DAKAILV'),
        value: 'openRate',
        color: 'rgba(107, 169, 255, 0.1)',
    },
    {
        label: getIn18Text('HUIFULV'),
        value: 'replyRate',
        color: 'rgba(141, 214, 188, 0.1)',
    },
    {
        label: getIn18Text('SHIYONGSHU'),
        value: 'usedCount',
        color: 'rgba(255, 170, 0, 0.1)',
    },
];
const defaultData = { usedCount: 0, openRate: '0%', replyRate: '0%' };
const Preview = props => {
    const { templateId, allTemplateId, closeModal, emitResult, fromPage = 1, closeAllModal, onUse } = props;
    const [usedData, setUsedData] = useState(defaultData);
    const [content, setContent] = useState('');
    const [currentId, setCurrentId] = useState('');
    const [templateName, setTemplateName] = useState('');
    const [templateContentType, setTemplateContentType] = useState(0);
    const [templateDesc, setTemplateDesc] = useState('');
    const frameRef = useRef(null);
    const doGetMailTemplateDetail = async (needStatistics = false) => {
        if (!currentId)
            return;
        const res = await templateApi.doGetMailTemplateDetail({ templateId: currentId, needStatistics });
        if (res.success && res.data) {
            const { templateName, content, usedCount, openRate, replyRate, templateDesc, templateContentType } = res.data;
            setUsedData({ usedCount: usedCount || 0, openRate: openRate || '0%', replyRate: replyRate || '0%' });
            setContent(content);
            setTemplateName(templateName);
            setTemplateContentType(templateContentType);
            setTemplateDesc(templateDesc);
        }
    };
    const renderData = () => {
        const span = 24 / dataMap.length;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.dataTitle },
                React.createElement("div", { className: classes.dataIcon }),
                getIn18Text('MOBANSHUJU')),
            React.createElement(Row, { justify: "space-between", gutter: 16 }, dataMap.map(data => {
                return (React.createElement(Col, { span: span },
                    React.createElement("div", { className: classes.dataItem, style: { background: `${data.color}` } },
                        React.createElement("div", { className: classes.dataLabel }, data.label),
                        React.createElement("div", { className: classes.dataValue }, usedData[data.value]))));
            }))));
    };
    const chengeTemplate = (behavior) => {
        const index = allTemplateId.indexOf(currentId);
        const newTemplateId = behavior === 'previous' ? allTemplateId[index - 1] : allTemplateId[index + 1];
        if (index === -1 || !newTemplateId) {
            message.error({
                content: getIn18Text('MEIYOUGENGDUODEMOBAN\uFF01'),
            });
            return;
        }
        setCurrentId(newTemplateId);
    };
    const applyTemplate = () => {
        templateApi.doSaveMailTemplateUseTime({ templateId: currentId, time: new Date().getTime() });
        templateApi.doGetMailTemplateDetail({ templateId: currentId }).then(async (res) => {
            if (res.success && res.data) {
                if (onUse) {
                    onUse(res.data.content, templateId);
                }
                else if (emitResult) {
                    const viewMail = await formatViewMail(res.data);
                    viewMail.form = 'template';
                    emitResult(viewMail);
                }
                else {
                    setTemplateContent(res.data.content, currentId);
                    navigate('#edm?page=write&from=template');
                }
            }
        });
    };
    useEffect(() => {
        if (frameRef.current) {
            frameRef.current.setAttribute('style', 'padding:10px');
            const doc = frameRef.current.contentDocument;
            doc === null || doc === void 0 ? void 0 : doc.open();
            doc === null || doc === void 0 ? void 0 : doc.write(readWrapper(content || '', true));
            doc === null || doc === void 0 ? void 0 : doc.close();
        }
    }, [content]);
    const closeModalByPage = () => {
        if (fromPage === 2 && closeAllModal) {
            closeAllModal();
        }
        else {
            closeModal();
        }
    };
    useEffect(() => {
        setCurrentId(templateId);
    }, [templateId]);
    useEffect(() => {
        if (currentId) {
            doGetMailTemplateDetail(false);
        }
    }, [currentId]);
    return (React.createElement("div", { className: classes.preview },
        React.createElement("div", { className: classes.header, style: isWindows ? {
                paddingTop: 56,
            } : {} },
            React.createElement("div", { className: classes.title },
                fromPage === 2 && React.createElement(IconBack, { className: classes.icon, onClick: closeModal }),
                templateName),
            React.createElement("div", null,
                React.createElement(IconClose, { style: { cursor: 'pointer' }, onClick: closeModalByPage }))),
        React.createElement("div", { className: classes.data }, renderData()),
        templateContentType === 1 && !!templateDesc && (React.createElement("div", { className: classes.templateDesc },
            React.createElement("div", { className: classes.templateDescTitle },
                React.createElement("div", { className: classes.dataIcon }),
                getIn18Text('MOBANJIANJIE')),
            templateDesc)),
        React.createElement("div", { className: classes.content },
            React.createElement("iframe", { title: getIn18Text('YULAN'), ref: frameRef, width: "100%", height: "100%", src: "about:blank", frameBorder: "0" })),
        React.createElement("div", { className: classes.footer },
            React.createElement("div", { className: classes.buttons }, allTemplateId != null && allTemplateId.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Button, { className: classes.button, style: { marginRight: '12px' }, onClick: () => {
                        chengeTemplate('previous');
                    } },
                    React.createElement(IconLeft, null),
                    " ",
                    getIn18Text('SHANGYIGE')),
                React.createElement(Button, { className: classes.button, onClick: () => {
                        chengeTemplate('next');
                    } },
                    getIn18Text('XIAYIGE'),
                    React.createElement(IconRight, null))))),
            React.createElement("div", null,
                React.createElement(Button, { type: "primary", onClick: applyTemplate }, getIn18Text('SHIYONG'))))));
};
export default Preview;
